import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SanEngineManager } from "../../engine/SanEngineManager";
import { SanParsedGameData } from "../../server/data/SanParsedGameData";

export class ReelCorrection extends Presentation {

    public checkForActivation(data:SanParsedGameData):boolean{
        return !!data;
    }

    public getPresentation(): void {
        SanEngineManager.onBeforeSpinStart();
        this.PresentationState.set(PresentationState.INACTIVE);
    }
}

